module.exports = __webpack_public_path__ + "img/Industrial.452a4d8b.png";